var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"cardListPublic"},_vm._l((_vm.cardList),function(v,i){return _c('li',{key:i,style:({ width: 100 / (_vm.cardList.length + 2) + '%' })},[_c('h5',[_vm._v(_vm._s(_vm._f("handleNumPublicFun")(v.value)))]),_c('p',[_vm._v(_vm._s(v.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }